<!-- Template to expose the current action button to parent -->
<ng-template #accountSetupActionButton>
  <ng-container *ngTemplateOutlet="currentActionButtonTemplate()"></ng-container>
</ng-template>

<div class="account-setup-wrapper">
  <span class="scroll-anchor" #scrollAnchor></span>
  <ng-container *ngIf="user && !processing && !isLoadingPaymentPageData(); else loading">
    <client-setup-progress-bar
      *ngIf="!useInSessionRequest && !isProposeATime && !onCostEstimation() && !fromDirectBooking()"
      [showProgress]="true"
      [progressBarValue]="progressBarValue"
      [progressBarHeader]="progressBarHeader"
    ></client-setup-progress-bar>
    <client-setup-basic-info
      #basicInfoComponent
      *ngIf="onBasicInfo()"
      [useInSessionRequest]="useInSessionRequest"
      [isProposeATime]="isProposeATime"
      [isMobile]="isMobile"
      (basicInfoSubmitted)="setupDataSubmitted()"
      [fromDirectBooking]="fromDirectBooking()"
    ></client-setup-basic-info>
    <client-setup-eap-info
      #eapInfoComponent
      *ngIf="onEAP()"
      [useInSessionRequest]="useInSessionRequest"
      [isMobile]="isMobile"
      [isProposeATime]="isProposeATime"
      [user]="user"
      [fromDirectBooking]="fromDirectBooking()"
      (eapInfoSubmitted)="setupDataSubmitted($any($event))"
      (eapSkippedToInsurance)="eapToInsurance()"
    ></client-setup-eap-info>
    <client-setup-insurance-info
      #insuranceInfoComponent
      *ngIf="onInsurance()"
      [useInSessionRequest]="useInSessionRequest"
      [isProposeATime]="isProposeATime"
      [isMobile]="isMobile"
      [user]="user"
      (insuranceInfoSubmitted)="setupDataSubmitted($event)"
      [costEstimateContext]="costEstimateContext"
      [fromDirectBooking]="fromDirectBooking()"
    ></client-setup-insurance-info>
    <client-insurance-review
      #insuranceReviewComponent
      *ngIf="onInsuranceReview()"
      [useInSessionRequest]="useInSessionRequest"
      [isMobile]="isMobile"
      [isEAP]="isEAPReview()"
      [fromDirectBooking]="fromDirectBooking()"
      (closeReview)="setupDataSubmitted()"
    ></client-insurance-review>
    <client-insurance-verification-failed
      #insuranceVerificationFailedComponent
      *ngIf="onInsuranceVerificationFailed()"
      [isMobile]="isMobile"
      [fromDirectBooking]="fromDirectBooking()"
      (closeReview)="setupDataSubmitted()"
    ></client-insurance-verification-failed>
    <client-cost-estimation
      #costEstimationComponent
      *ngIf="onCostEstimation() && !isSelfPayCostEstimate()"
      [accountSetupType]="accountSetupType"
      [fromDirectBooking]="fromDirectBooking()"
      [userHasSuccessfulMostRecentBv]="userHasSuccessfulMostRecentBv"
      (costEstimationReviewed)="onCostEstimationReviewed()"
    ></client-cost-estimation>
    <client-self-pay-cost-estimation
      #selfPayCostEstimationComponent
      *ngIf="onCostEstimation() && selfPayEstimatesFeatureEnabled() && isSelfPayCostEstimate()"
      [fromDirectBooking]="fromDirectBooking()"
      [personaClientId]="user?.personaId"
      (costEstimationReviewed)="onCostEstimationReviewed()"
    ></client-self-pay-cost-estimation>
    <client-setup-payment-info
      #paymentInfoComponent
      *ngIf="onPayment()"
      [useInSessionRequest]="useInSessionRequest"
      [isMobile]="isMobile"
      [isProposeATime]="isProposeATime"
      [showPaymentFaq]="showPaymentFaq"
      (paymentInfoSubmitted)="setupDataSubmitted()"
      [fromDirectBooking]="fromDirectBooking()"
    ></client-setup-payment-info>
    <client-setup-ebcg-payment-info
      #ebcgPaymentInfoComponent
      *ngIf="onEbcgPayment()"
      [useInSessionRequest]="useInSessionRequest"
      [providerName]="providerName()"
      [userProfile]="user?.profile"
      (paymentInfoSubmitted)="setupDataSubmitted()"
      (exitSetup)="setupExited.emit()"
      [fromDirectBooking]="fromDirectBooking()"
    ></client-setup-ebcg-payment-info>
  </ng-container>

  <ng-template #loading>
    <div class="loading">
      <mat-spinner diameter="100"></mat-spinner>
    </div>
  </ng-template>
</div>
